import PageViewer from "@/components/PageViewer";
import PERMISSIONS from "@/common/permissions-lib";

export default {
	path: "/WorkerPresence",
	meta: {
		breadcrumb: "WorkerPresence",
		authorizedRoles: [PERMISSIONS.WP_VIEW]
	},
	component: PageViewer,
	props: { pageTransition: "none" },
	children: [
		{
			path: "/WorkerPresence",
			name: "WorkerPresence",
			props: { pageTransition: "none" },
			component: () =>
				import(
					/* webpackChunkName: "TFlowRestriction" */ "@/views/WorkerPresence/WorkerPresenceMain"
				)
		},
		{
			path: "/WorkerPresence/:projectId",
			name: "WorkerPresence.projectId",
			props: route => {
				return {
					projectId: route.params.projectId
				};
			},
			meta: {
				breadcrumb() {
					return `WorkerPresence ProjectId:` + this.$route.params.projectId;
				}
			},
			component: () =>
				import(
					/* webpackChunkName: "MOT.motId" */ "@/views/WorkerPresence/WorkerPresenceMain"
				)
		},
		{
			path: "/WorkerPresence/:contractorId",
			name: "WorkerPresence.contractorId",
			props: route => {
				return {
					contractorId: route.params.contractorId
				};
			},
			meta: {
				breadcrumb() {
					return (
						`WorkerPresence contractorId:` + this.$route.params.contractorId
					);
				}
			},
			component: () =>
				import(
					/* webpackChunkName: "MOT.motId" */ "@/views/WorkerPresence/WorkerPresenceMain"
				)
		}
	]
};
